import React from 'react';
import { FormLabel, chakra } from '@chakra-ui/react';

export const Label = ({ children, htmlFor, ...props }) => (
  <FormLabel mb="2" htmlFor={htmlFor} {...props}>
    <chakra.strong display="flex">{children}</chakra.strong>
  </FormLabel>
);
